var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 462,
    viewBox: "0 0 590 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4 448L49.3 439.2H21.7L17.6 448H0.1V445.4L31.6 377.1H39.3L70.9 445.4V448H53.4ZM43.5 423.9L35.4 405.5L27.5 423.9H43.5ZM75.7914 413C75.8914 389.1 93.8914 377.1 111.691 377.1C125.791 377.2 140.491 384.5 143.891 401.9H126.291C123.391 395.9 118.791 393.5 111.691 393.5C100.391 393.5 94.2914 402.3 94.2914 413C94.2914 424.6 101.091 432.2 111.691 432.2C118.891 432.2 123.491 430.3 126.691 423.6H111.791V408.1H144.891C145.291 415.1 145.291 421.8 142.891 428.6C137.891 443.2 124.591 448.8 111.691 448.8C93.8914 448.8 75.8914 436.9 75.7914 413ZM204.495 423.2L218.195 445.4V448H198.195L186.195 427.4H176.895V448C170.895 448 164.795 448 158.995 448C158.995 424.7 158.995 401.4 158.995 378C169.095 378 179.495 378 189.695 378C217.195 378.1 222.195 411.2 204.495 423.2ZM189.695 411.3C199.395 411.3 199.895 394.1 189.695 394C185.495 393.9 181.095 394 176.895 394C176.895 399.7 176.895 405.7 176.895 411.3H189.695ZM296.517 413.1C296.517 461.6 224.717 461.6 224.717 413.1C224.717 364.7 296.517 364.7 296.517 413.1ZM243.117 413.1C243.117 438.5 278.217 438.5 278.217 413.1C278.217 387.9 243.117 387.9 243.117 413.1ZM327.874 378C327.874 414.2 327.874 402.1 327.874 431.9H353.274C353.274 437.9 353.274 442 353.274 448C338.874 448 324.074 448 309.874 448V378C315.874 378 321.774 378 327.874 378ZM413.166 448L409.066 439.2H381.466L377.366 448H359.866V445.4L391.366 377.1H399.066L430.666 445.4V448H413.166ZM403.166 423.8L395.166 405.4L387.366 423.8H403.166ZM493.657 448.1L458.357 413.6V448C452.157 448 445.957 448 439.857 448V377.7H446.357L481.757 412.3V378C487.857 378 493.957 378 500.057 378V448.1H493.657ZM544.284 378C589.884 378.2 589.884 447.8 544.284 448H517.884V378H544.284ZM535.784 394.3V431.7H544.284C566.584 431.7 566.584 394.3 544.284 394.3H535.784Z",
    fill: "#6FA110"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.816 311L239.832 308.888H233.208L232.224 311H228.024V310.376L235.584 293.984H237.432L245.016 310.376V311H240.816ZM238.44 305.216L236.496 300.8L234.6 305.216H238.44ZM251.59 298.04V311C250.15 311 248.686 311 247.222 311V294.2C250.654 294.2 254.254 294.2 257.686 294.2C257.686 295.616 257.686 296.6 257.686 298.04H251.59ZM264.971 311C263.531 311 262.091 311 260.675 311C260.675 305.408 260.675 299.816 260.675 294.2C263.099 294.2 265.595 294.2 268.067 294.2C276.107 294.224 276.107 306.704 268.067 306.704H264.971V311ZM268.043 302.84C270.395 302.84 270.539 298.064 268.043 298.04C267.035 298.016 265.955 298.04 264.971 298.04C264.971 299.408 264.971 301.472 264.971 302.84H268.043ZM293.539 302.624C293.539 314.264 276.307 314.264 276.307 302.624C276.307 291.008 293.539 291.008 293.539 302.624ZM280.723 302.624C280.723 308.72 289.147 308.72 289.147 302.624C289.147 296.576 280.723 296.576 280.723 302.624ZM311.265 302.576C311.265 300.176 309.537 299.552 307.689 299.48V305.696C309.441 305.6 311.265 304.976 311.265 302.576ZM300.129 302.576C300.129 304.976 301.953 305.6 303.705 305.696V299.48C301.857 299.552 300.129 300.176 300.129 302.576ZM303.657 311.072V309.656C299.313 309.512 295.737 307.808 295.737 302.576C295.737 297.368 299.289 295.688 303.633 295.544V294.128H307.761V295.544C312.105 295.688 315.657 297.368 315.657 302.576C315.657 307.808 312.081 309.512 307.737 309.656V311.072H303.657ZM329.382 294.2C329.382 295.448 329.382 296.744 329.382 298.04C326.886 298.04 325.638 298.04 323.166 298.04V300.416H328.878C328.878 301.688 328.878 302.96 328.878 304.232H323.166C323.166 305.216 323.166 306.176 323.166 307.184C325.638 307.184 327.078 307.184 329.598 307.184C329.598 308.432 329.598 309.728 329.598 311C325.662 311 322.782 311 318.894 311C318.894 305.384 318.894 299.768 318.894 294.2C322.782 294.2 325.446 294.2 329.382 294.2ZM337.58 311C336.14 311 334.7 311 333.284 311C333.284 305.408 333.284 299.816 333.284 294.2C335.708 294.2 338.204 294.2 340.676 294.2C348.716 294.224 348.716 306.704 340.676 306.704H337.58V311ZM340.652 302.84C343.004 302.84 343.148 298.064 340.652 298.04C339.644 298.016 338.564 298.04 337.58 298.04C337.58 299.408 337.58 301.472 337.58 302.84H340.652ZM358.085 301.448L364.781 294.152H366.317V311C364.853 311 363.389 311 361.924 311V303.512L358.349 307.256H357.869L354.317 303.512V311C352.853 311 351.389 311 349.925 311V294.152H351.509L358.085 301.448ZM381.277 311L380.293 308.888H373.669L372.685 311H368.485V310.376L376.045 293.984H377.893L385.477 310.376V311H381.277ZM378.901 305.216L376.957 300.8L375.061 305.216H378.901Z",
    fill: "#6FA110"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.043 0H212.173V316.831H202.953C194.722 316.798 186.838 313.609 181.018 307.959C175.198 302.309 171.914 294.655 171.88 286.665V19.5748C171.891 14.3866 174.019 9.4141 177.798 5.74551C181.577 2.07692 186.699 0.0110387 192.043 0Z",
    fill: "#6FA110"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_108_8890",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 0,
    width: 42,
    height: 317
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.043 0H212.173V316.831H202.953C194.722 316.798 186.838 313.609 181.018 307.959C175.198 302.309 171.914 294.655 171.88 286.665V19.5748C171.891 14.3866 174.019 9.4141 177.798 5.74551C181.577 2.07692 186.699 0.0110387 192.043 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_108_8890)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_108_8890)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.915 58.9169C114.823 58.9169 78.2744 94.0659 78.2744 137.467C78.2744 180.867 114.856 216.027 159.915 216.027C204.975 216.027 241.546 180.836 241.546 137.467C241.546 94.0972 204.964 58.9169 159.915 58.9169Z",
    fill: "#358B1E"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M544.57 60.8177H468.029C460.283 60.85 452.815 63.6277 447.03 68.6287C441.245 73.6297 437.54 80.5097 436.612 87.9758H396.168C397.142 70.1009 405.134 53.2678 418.5 40.9383C431.867 28.6088 449.591 21.7202 468.029 21.6891H584.852V135.127C584.81 153.633 577.218 171.37 563.739 184.457C550.259 197.543 531.99 204.913 512.927 204.954H453.87V196.013C453.887 188.017 457.166 180.354 462.989 174.7C468.813 169.047 476.707 165.863 484.942 165.847H512.916C521.296 165.808 529.322 162.559 535.247 156.806C541.173 151.054 544.519 143.262 544.559 135.127V60.8177H544.57Z",
    fill: "#6FA110"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_108_8890",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 396,
    y: 21,
    width: 189,
    height: 184
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M544.57 60.8177H468.029C460.283 60.85 452.815 63.6277 447.03 68.6287C441.245 73.6297 437.54 80.5097 436.612 87.9758H396.168C397.142 70.1009 405.134 53.2678 418.5 40.9383C431.867 28.6088 449.591 21.7202 468.029 21.6891H584.852V135.127C584.81 153.633 577.218 171.37 563.739 184.457C550.259 197.543 531.99 204.913 512.927 204.954H453.87V196.013C453.887 188.017 457.166 180.354 462.989 174.7C468.813 169.047 476.707 165.863 484.942 165.847H512.916C521.296 165.808 529.322 162.559 535.247 156.806C541.173 151.054 544.519 143.262 544.559 135.127V60.8177H544.57Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_108_8890)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_108_8890)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.796 -26.3913C348.744 -26.3913 329.143 -20.6187 312.47 -9.80332C295.798 1.01202 282.803 16.3843 275.13 34.3695C267.456 52.3548 265.448 72.1453 269.36 91.2383C273.272 110.331 282.928 127.869 297.107 141.635C311.286 155.4 329.351 164.774 349.017 168.572C368.684 172.37 389.069 170.421 407.594 162.971C426.12 155.521 441.954 142.906 453.094 126.719C464.234 110.533 470.18 91.5032 470.18 72.0361C470.18 59.1104 467.558 46.3113 462.463 34.3695C457.368 22.4278 449.9 11.5772 440.486 2.43738C431.071 -6.70245 419.895 -13.9526 407.594 -18.899C395.294 -23.8454 382.11 -26.3913 368.796 -26.3913Z",
    fill: "#358B1E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_108_8890)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.2 111.486C385.108 111.486 348.559 146.676 348.559 190.046C348.559 233.415 385.14 268.606 430.2 268.606C475.259 268.606 511.83 233.447 511.83 190.046C511.83 146.645 475.281 111.486 430.2 111.486Z",
    fill: "#358B1E"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M364.458 0C382.989 0.0410328 400.792 7.00898 414.171 19.4573C427.551 31.9056 435.478 48.8779 436.308 66.8508H436.383V316.831H427.227C418.994 316.801 411.108 313.613 405.286 307.963C399.464 302.312 396.177 294.657 396.143 286.665V69.8696C396.104 61.7319 392.76 53.9376 386.838 48.1784C380.916 42.4193 372.893 39.1599 364.511 39.1077H287.873V113.417C287.916 121.562 291.268 129.363 297.201 135.123C303.134 140.883 311.169 144.137 319.559 144.178H347.759C355.986 144.217 363.864 147.408 369.679 153.058C375.495 158.707 378.776 166.358 378.81 174.345V183.286H319.527C300.455 183.234 282.18 175.856 268.693 162.765C255.207 149.673 247.605 131.932 247.548 113.417V0H364.458Z",
    fill: "#6FA110"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.878 39.1077H71.9361C63.5496 39.149 55.5192 42.4045 49.593 48.1658C43.6668 53.927 40.3244 61.7275 40.2933 69.8696V183.286H0V69.8696C0.0312707 51.3537 7.61925 33.6045 21.1022 20.5089C34.5851 7.41332 52.8641 0.0386649 71.9361 0H212.172V113.417C212.153 126.54 208.334 139.394 201.15 150.511C193.966 161.628 183.708 170.56 171.545 176.288V118.002C171.772 116.484 171.884 114.951 171.878 113.417V39.1077ZM171.545 176.288C161.791 180.897 151.084 183.291 140.236 183.286H57.5403V174.345C57.5545 166.347 60.8343 158.68 66.6608 153.026C72.4873 147.371 80.3852 144.189 88.6237 144.178H140.268C147.841 144.143 155.153 141.489 160.891 136.691C166.629 131.894 170.418 125.267 171.577 118.002V176.288H171.545Z",
    fill: "#6FA110"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_108_8890",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 213,
    height: 184
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M171.878 39.1077H71.9361C63.5496 39.149 55.5192 42.4045 49.593 48.1658C43.6668 53.927 40.3244 61.7275 40.2933 69.8696V183.286H0V69.8696C0.0312707 51.3537 7.61925 33.6045 21.1022 20.5089C34.5851 7.41332 52.8641 0.0386649 71.9361 0H212.172V113.417C212.153 126.54 208.334 139.394 201.15 150.511C193.966 161.628 183.708 170.56 171.545 176.288V118.002C171.772 116.484 171.884 114.951 171.878 113.417V39.1077ZM171.545 176.288C161.791 180.897 151.084 183.291 140.236 183.286H57.5403V174.345C57.5545 166.347 60.8343 158.68 66.6608 153.026C72.4873 147.371 80.3852 144.189 88.6237 144.178H140.268C147.841 144.143 155.153 141.489 160.891 136.691C166.629 131.894 170.418 125.267 171.577 118.002V176.288H171.545Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_108_8890)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_108_8890)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5521 123.761C5.4602 123.761 -31.0889 158.952 -31.0889 202.321C-31.0889 245.691 5.49248 280.871 50.5521 280.871C95.6117 280.871 132.182 245.722 132.182 202.321C132.182 158.92 95.6009 123.761 50.5521 123.761Z",
    fill: "#358B1E"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 83.2501H40.2933V316.831H31.0726C22.8421 316.798 14.9584 313.609 9.13851 307.959C3.31862 302.309 0.0339874 294.655 0 286.665V83.2501Z",
    fill: "#6FA110"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_108_8890",
    x: 48.2744,
    y: 28.9169,
    width: 223.271,
    height: 217.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_108_8890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_108_8890",
    x: 237.412,
    y: -56.3913,
    width: 262.769,
    height: 256.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_108_8890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_108_8890",
    x: 318.559,
    y: 81.4858,
    width: 223.271,
    height: 217.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_108_8890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_108_8890",
    x: -61.0889,
    y: 93.7611,
    width: 223.271,
    height: 217.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_108_8890"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b2c89b642fc2868a94832d84bba051a3.svg";
export { ForwardRef as ReactComponent };